import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const fetchCarousels = createAsyncThunk("Carousels/fetchAll", async () => {
    return await ApiService.get("/carousel",false);
  });
  
  export const fetchCarouselById = createAsyncThunk("Carousels/fetchById", async (id) => {
    return await ApiService.getById("/posts", id);
  });
  
  